export default __webpack_public_path__ + "static/media/background-stalls.0e48d5ee.svg";